import React from "react";
import logodiv from "./assets/images/vector.png";
import {useMediaQuery} from "react-responsive";
const Banner = () => {
    const isBigScreen = useMediaQuery({query: "(min-width: 750px)"});
    const isTabletOrMobile = useMediaQuery({query: "(max-width: 600px)"});
    return (

        <div className="container pt-10 mx-auto mx-45 px-0">
          <div className="flex-container">
            <div className="flex-item">
            {isTabletOrMobile && <h1 className="text-center pr-8 font-bold text-[28px] w-auto ml-[12px]">
                    Mitra Space
                </h1>}
              <img
                style={{width: "100%", paddingLeft: 30}}
                src="https://media.graphassets.com/5iK9wAHiQmCcu1avnWYK"
                alt=""
                className="w-full"
              />
            </div>
            <div className="flex-item">
              <div>
                {isBigScreen && <h1 className="pr-8 font-bold text-[28px] w-auto ml-[12px]">
                    Mitra Space
                </h1>}
                <p className="pr-8 w-auto md:w-[660px] ml-[12px]">
                    Bisnis cargo adalah salah satu bisnis yang tetap bersinar dimasa pandemi ini.
                    Sekarang kami hadir menawarkan peluang usaha untuk Anda dengan menjadi Mitra
                    Space Trawlbens.
                </p>
                <div className="items-center mb-19 flex mt-4 ml-4">
                  <img className="flex-none h-6 md:h-14" src={logodiv} alt=""/>
                  <div className=" flex-1 w-64">
                      <h1 className="pr-8 font-bold w-auto ml-[12px] text-[12.25px] leading-4 md:text-[26px] md:leading-9">
                          Bisnis cargo berbasis aplikasi
                      </h1>
                      <p className="pr-8 font-light w-auto ml-[12px] text-[9.42px] leading-3 md:w-[400px] md:text-[20px] md:leading-6">
                          Dapatkan kemudahan untuk kontrol bisnis logistik lewat aplikasi, dimana saja dan
                          kapan saja.
                      </p>
                  </div>
                </div>
                <div className="items-center mb-19 flex mt-4 ml-4">
                  <img className="flex-none h-6 md:h-14" src={logodiv} alt=""/>
                  <div className="flex-1 w-64">
                      <h1 className="pr-8 font-bold w-auto ml-[12px] text-[12.25px] leading-4 md:text-[26px] md:leading-9">
                          Menjangkau seluruh Indonesia</h1>
                      <p className="pr-8 font-light w-auto ml-[12px] text-[9.42px] leading-3 md:w-[400px] md:text-[20px] md:leading-6">
                          Layani pengiriman paket kecil dan barang besar ke seluruh Indonesia dengan
                          asuransi keamanan
                      </p>
                  </div>
                </div>
                <div className="items-center mb-19 flex mt-4 ml-4">
                  <img className="h-6 md:h-14 flex-none" src={logodiv} alt=""/>
                  <div className="flex-1 w-64">
                      <h1 className="pr-8 font-bold w-auto ml-[12px] text-[12.25px] leading-4 md:text-[26px] md:leading-9">
                          Balik modal hanya 1 bulan</h1>
                      <p className="pr-8 font-light w-auto ml-[12px] text-[9.42px] leading-3 md:w-[400px] md:text-[20px] md:leading-6">
                          Raih keuntungan hingga puluhan juta dan balik modal dalam waktu cepat
                      </p>
                  </div>
                </div>
                <div className="items-center mb-19 flex mt-4 ml-4">
                  <img className="h-6 md:h-14 flex-none" src={logodiv} alt=""/>
                  <div className="flex-1 w-64">
                      <h1 className="pr-8 font-bold w-auto ml-[12px] text-[12.25px] leading-4 md:text-[26px] md:leading-9">
                          Ongkos kirim paling murah
                      </h1>
                      <p className="pr-8 font-light w-auto ml-[12px] text-[9.42px] leading-3 md:w-[400px] md:text-[20px] md:leading-6">
                          Biaya pengiriman paket kecil maupun barang besar lebih murah dari jasa ekspedisi
                          lainnya, sehingga punya daya saing bisnis yang baik
                      </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
};

export default Banner;
